import cartFunctions from './cartFunctions';

export default {
  functions: [
    ...cartFunctions,
    {
      name: 'getPLPProducts',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'plpProducts',
      },
    },
  ],
};
